// Generated from pinned field-meaning declarations, keyed by observation source; do not edit.
import type { SkillFieldMeanings } from '../src/issues/field-meanings';
import { fieldMeanings as meanings0 } from '../skills/sf-311/scripts/field-meanings';
import { fieldMeanings as meanings1 } from '../skills/sf-assessor/scripts/field-meanings';
import { fieldMeanings as meanings2 } from '../skills/sf-dbi/scripts/field-meanings';
import { fieldMeanings as meanings3 } from '../skills/sf-fire-compliance/scripts/field-meanings';
import { fieldMeanings as meanings4 } from '../skills/sf-fire-inspections/scripts/field-meanings';
import { fieldMeanings as meanings5 } from '../skills/sf-fire-violations/scripts/field-meanings';
import { fieldMeanings as meanings6 } from '../skills/sf-public-works/scripts/field-meanings';
import { fieldMeanings as meanings7 } from '../skills/sf-recorder/scripts/field-meanings';
import { fieldMeanings as meanings8 } from '../skills/sf-rent-board/scripts/field-meanings';
import { fieldMeanings as meanings9 } from '../skills/sf-section604/scripts/field-meanings';
import { fieldMeanings as meanings10 } from '../skills/sf-subdivision/scripts/field-meanings';
import { fieldMeanings as meanings11 } from '../skills/sf-treasurer/scripts/field-meanings';
import { fieldMeanings as meanings12 } from '../skills/us-street-view/scripts/field-meanings';
export const fieldMeaningsBySource: Record<string, SkillFieldMeanings> = {
  'sf311': meanings0,
  'assessor': meanings1,
  'dbi': meanings2,
  'fire-compliance': meanings3,
  'fire-inspections': meanings4,
  'fire-violations': meanings5,
  'public-works': meanings6,
  'recorder': meanings7,
  'sf-rent-board': meanings8,
  'section604': meanings9,
  'subdivision': meanings10,
  'sf-treasurer': meanings11,
  'us-street-view': meanings12,
};
